import { render, staticRenderFns } from "./SectionWithImageAndItems.vue?vue&type=template&id=5a381bc7&"
import script from "./SectionWithImageAndItems.vue?vue&type=script&lang=js&"
export * from "./SectionWithImageAndItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports